module.exports = __webpack_public_path__ + "img/sankaku_56_red.a026f864.png";